<template>
  <button
    :type="type"
    class="
      inline-flex
      items-center
      px-4
      py-2
      h-9
      bg-white
      border border-gray-300
      rounded-md
      font-medium
      text-xs text-gray-700
      hover:text-gray-500
      focus:outline-none
      focus:border-blue-300
      focus:ring focus:ring-blue-200
      active:text-gray-800
      active:bg-gray-50
      disabled:opacity-25
      transition
    "
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
  },
};
</script>
